/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_mobile_analytics_app_id": "2d420f3b804b4e97809222b8287e352b",
    "aws_mobile_analytics_app_region": "eu-west-1",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "2d420f3b804b4e97809222b8287e352b",
            "region": "eu-west-1"
        }
    },
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://bhqc2vye9g.execute-api.eu-west-2.amazonaws.com/uat",
            "region": "eu-west-2"
        },
        {
            "name": "apinotifications",
            "endpoint": "https://h76edsingh.execute-api.eu-west-2.amazonaws.com/uat",
            "region": "eu-west-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://wb6hh2lftjdr7cukqd4t22eaey.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-2ma2vuebwraxvn6rwamp3kixmi",
    "aws_cognito_identity_pool_id": "eu-west-2:01fc30d3-5590-41bc-a56c-bd87acd203aa",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_Wk7IopcV2",
    "aws_user_pools_web_client_id": "78qld65c6sttspk5r9gmjte5ip",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS",
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
